import { Role, RoleList } from './interfaces'

export const normalizeRoles = (roles: RoleList) => {
  const { mainRoles, customRoles } = roles
  let normalizedRoles = []
  const mainRolesTitle = { id: 'main-role-title', name: 'title', value: 'PRIMARY USER ROLE' }
  const customRolesTitle = { id: 'custom-role-title', name: 'title', value: 'CUSTOM USER ROLE' }
  const separator = { id: 'separator', name: 'separator', value: 'separator' }
  normalizedRoles.push(mainRolesTitle)
  normalizedRoles.push(...normalizeUserRoles(mainRoles))
  if (Array.isArray(customRoles)) {
    normalizedRoles.push(separator)
    normalizedRoles.push(customRolesTitle)
    normalizedRoles.push(...normalizeUserRoles(customRoles))
  }
  return normalizedRoles
}

const normalizeUserRoles = (roles: Array<Role>) => {
  return roles.map((role: Role) => ({
    id: role.id,
    name: role.label,
    value: role.name
  }))
}
